import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Injector } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MaterialModule } from './shared/material/material.module';
import { MainModuleModule } from './modules/main-module/main-module.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ShopManagerComponent } from './shop-manager/shop-manager.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import {
  GoogleTagManagerModule,
  GoogleTagManagerService,
} from 'angular-google-tag-manager';
import { LucideAngularModule, icons } from 'lucide-angular';
import { ShopModule } from './modules/shop/shop.module';
import { Interceptor } from './services/interceptor/interceptor.interceptor';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ElementsModule } from './shared/elements/elements.module';
import { RegistrationModuleModule } from './modules/registration-module/registration-module.module';
import { LayoutManagerModule } from './layout-manager/layout-manager.module';
import { ShopManagerModule } from './shop-manager/shop-manager.module';
import { LoginModuleModule } from './modules/login-module/login-module.module';
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    MainModuleModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    NgxIntlTelInputModule,
    ToastrModule.forRoot(),
    ShopModule,
    InfiniteScrollModule,
    GoogleTagManagerModule.forRoot({
      id: 'GTM-WKCJJ5ZL',
    }),
    LucideAngularModule.pick(icons),
    //ElementsModule,
    RegistrationModuleModule,
    LayoutManagerModule,
    ShopManagerModule,
    LoginModuleModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi: true
    },
    { provide: 'googleTagManagerId', useValue: 'GTM-WKCJJ5ZL'},
    GoogleTagManagerService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private injector: Injector) {  }
}
